import { createContext, useContext } from "react";
import type { Project } from "@/pages/projects/hooks/useProject";

interface ProjectContextValue {
  project: Project;
  refetch: () => void;
}

const ProjectContext = createContext<ProjectContextValue | null>(null);

export const ProjectProvider = ProjectContext.Provider;

export function useProjectContext(): ProjectContextValue {
  const ctx = useContext(ProjectContext);
  if (!ctx) {
    throw new Error("useProjectContext must be used within a ProjectProvider");
  }
  return ctx;
}
